var map = {
	"./av_baboon.png": "bcb7",
	"./av_badger.png": "02f6",
	"./av_bear.png": "c56a",
	"./av_bee.png": "f46f",
	"./av_beta.png": "0130",
	"./av_bunny.png": "7740",
	"./av_butterfly.png": "ebf5",
	"./av_cardinal.png": "f3a3d",
	"./av_cat.png": "5b89",
	"./av_cockatoo.png": "ec1f",
	"./av_crab.png": "a9ada",
	"./av_crane.png": "dcc7",
	"./av_dragonfly.png": "7e6d",
	"./av_eagle.png": "53ed",
	"./av_egret.png": "ad17",
	"./av_elephant.png": "a3d9",
	"./av_flamingo.png": "e199",
	"./av_fox.png": "af6a",
	"./av_gazelle.png": "9c44",
	"./av_giraffe.png": "9968",
	"./av_gorilla.png": "c300",
	"./av_hedgehog.png": "1301",
	"./av_hippo.png": "c517",
	"./av_horse.png": "8ead",
	"./av_hummingbird.png": "7edc",
	"./av_iguna.png": "7af4",
	"./av_jellyfish.png": "061b",
	"./av_leopard.png": "2f9f",
	"./av_lion.png": "cddb",
	"./av_lionfish.png": "d4da",
	"./av_lizard.png": "db7c",
	"./av_macaw.png": "19ad",
	"./av_mantis.png": "768b",
	"./av_octopus.png": "03e5",
	"./av_orangutan.png": "83ed",
	"./av_osprey.png": "6a23",
	"./av_otter.png": "73d8",
	"./av_owl.png": "8828",
	"./av_panda.png": "5c74",
	"./av_pangolin.png": "329e",
	"./av_panther.png": "6ba5",
	"./av_peacock.png": "1eb2",
	"./av_penguin.png": "e175",
	"./av_polar bear.png": "403a",
	"./av_puffin.png": "19df",
	"./av_puppy.png": "b459",
	"./av_rhino.png": "b504",
	"./av_rooster.png": "f305",
	"./av_shark.png": "977f",
	"./av_sloth.png": "b74f",
	"./av_snake.png": "5029",
	"./av_squirrel.png": "0478",
	"./av_starfish.png": "8aa7e",
	"./av_stingray.png": "b302",
	"./av_tiger.png": "650e",
	"./av_tucan.png": "132f",
	"./av_turtle.png": "81a0",
	"./av_walrus.png": "2c30",
	"./av_whaleshark.png": "e99d",
	"./av_yak.png": "b95f",
	"./av_zebra.png": "2f1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "921a";